export var ComputationTypes;
(function (ComputationTypes) {
    ComputationTypes["column"] = "column";
    ComputationTypes["segment"] = "segment";
    ComputationTypes["metric"] = "metric";
})(ComputationTypes || (ComputationTypes = {}));

//# sourceMappingURL=MDLComputations.js.map
